<template>
    <div class="cart">
        <!--Top Bar-->
        <TopBar msg="Welcome to Your Vue.js App" />
        <!--Top Bar-->
        <LoadingView v-if="loading" />
        <v-divider></v-divider>

        <v-card elevation="0"
            class="bg-secondary mx-auto rounded-xl mt-n6 d-block d-md-none d-md-none d-lg-none d-xl-none d-xxl-none "
            height="100">
            <div class="d-flex flex-column fill-height justify-center align-center text-black">
                <h1 class="mobile-category-title-text">
                    Your Cart Summary
                </h1>
            </div>
        </v-card>

        <v-container>
            <v-row dense class="bg-white">
                <v-col cols="12" sm="12" md="12">

                    <!--Cart Web View-->
                    <v-card class="mx-auto bg-white d-none d-md-block d-md-block d-lg-block d-xl-block d-xxl-block"
                        elevation="0" max-width="1100">
                        <div class="d-flex flex-column text-left text-black ml-2">
                            <h1 class="font-weight-bold mt-4">
                                Your Cart Summary
                            </h1>
                            <p class="d-none text-subtitle-1 font-weight-bold ml-2 mt-2">
                                5 ITEMS
                            </p>
                        </div>

                        <v-alert type="success" color="primary" class="mt-10" v-if="getCart.total_amount == 0">
                            <p class="text-white text-left">Your cart is currently empty. Continue to<v-btn
                                    class="text-none ml-5" color="secondary" rounded="0" variant="tonal" href="/">
                                    SHOP
                                </v-btn></p>
                        </v-alert>

                        <v-row dense>
                            <v-col cols="12" sm="7" md="7">
                                <v-row dense>
                                    <v-col cols="9"> </v-col>
                                    <v-col cols="3" v-if="getCart.total_amount > 0">
                                        <v-btn color="amber-accent-4" rounded variant="tonal" size="small"
                                            class="text-center clear-cart" @click="clearcart()">
                                            <p class="text-black"><v-icon size="14">mdi-cart-remove</v-icon> Clear Cart
                                            </p>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <v-card class="ma-4 mx-auto rounded-xl " elevation="0" variant="outlined"
                                    color="#b8b8b8" v-if="getCart.total_amount > 0">
                                    <div v-for="item in getCart.cartitems" :key="item.id"
                                        class="d-flex flex-wrap justify-space-between">
                                        <v-avatar class="ma-3" size="65" rounded="0">
                                            <v-img :src="item.image"></v-img>
                                        </v-avatar>
                                        <div class="mt-3 cart-product-details">
                                            <div
                                                class="text-subtitle-1 text-black font-weight-bold text-wrap text-left ml-3">
                                                {{ item.product }} - {{ item.unit }}
                                            </div>

                                            <div class="rounded-xl text-left">
                                                <v-btn variant="text" min-height="30" class="text-left">
                                                    <p class="text-primary price-text text-subtitle-1 font-weight-bold">
                                                        Rs.{{ item.base_price }}</p>
                                                </v-btn>
                                                <template v-if="item.max_order_qty != '0'">
                                                    <v-btn size="20" variant="flat" color="primary" icon
                                                        @click="decrement(item)">
                                                        <v-icon color="white" size="14">mdi-minus</v-icon>
                                                    </v-btn>
                                                    <span class="text-black ml-2 mr-2">{{ item.qty }}</span>
                                                    <v-btn size="20" variant="flat" color="primary" icon
                                                        @click="increment(item)">
                                                        <v-icon color="white" size="14">mdi-plus</v-icon>
                                                    </v-btn>
                                                </template>
                                                <template v-else>
                                                    <v-btn color="orange" rounded variant="tonal" size="small"
                                                        min-width="70" min-height="30" class="text-center">
                                                        <p class="text-black">Sold Out</p>
                                                    </v-btn>
                                                </template>
                                            </div>

                                        </div>
                                        <div>
                                            <v-btn size="24" variant="outlined" color="primary" icon class="mt-3"
                                                @click="deleteItem(item)">
                                                <v-icon color="black" size="14">mdi-delete-outline</v-icon>
                                            </v-btn>
                                            <v-card-title class="text-subtitle-1 text-black font-weight-bold mt-4">
                                                Rs.{{ item.total_price }}
                                            </v-card-title>
                                        </div>
                                        <v-divider></v-divider>
                                    </div>
                                </v-card>

                                <p class="shiping-delivery-charge-content text-left" v-if="getCart.total_amount > 0">
                                    *Shipping charges may apply, based
                                    on your
                                    location.Our staff will communicate the charges, if any, before order
                                    dispatch*</p>
                            </v-col>
                            <v-col cols="12" sm="5" md="5" v-if="userLogin == true">
                                <v-card class="mx-auto bg-white" elevation="0" v-if="getCart.total_amount > 0"
                                    min-height="950" max-height="950">
                                    <v-row dense>
                                        <v-col cols="12" sm="12" md="12">
                                            <v-card class="ma-4 rounded-xl pa-5" elevation="0" variant="outlined" dark
                                                v-if="orderStatus == false">
                                                <div class="text-right ma-5">
                                                    <v-btn class="ma-2" color="primary" @click="addressDialog = true"
                                                        variant="outlined">
                                                        <v-icon color="primary" size="25">mdi-account-edit</v-icon>
                                                        Edit
                                                    </v-btn>
                                                </div>

                                                <form class="mt-5 ma-5">

                                                    <v-text-field v-model="getAddress.name" label="Name"
                                                        variant="outlined" color="black" type="text" class="mb-2"
                                                        disabled></v-text-field>

                                                    <v-text-field v-model="getAddress.mobile" label="Mobileno"
                                                        variant="outlined" color="black" type="number" class="mb-2"
                                                        disabled></v-text-field>

                                                    <v-text-field v-model="getAddress.email" label="Email"
                                                        variant="outlined" color="black" type="text" class="mb-2"
                                                        disabled></v-text-field>

                                                    <v-text-field v-model="getAddress.flat_door_no"
                                                        label="Flat / Address No" variant="outlined" color="black"
                                                        type="text" class="mb-2" disabled></v-text-field>

                                                    <v-text-field v-model="getAddress.address" label="Address"
                                                        variant="outlined" color="black" type="text" class="mb-2"
                                                        disabled></v-text-field>

                                                    <v-text-field v-model="getAddress.address2" label="Address 2"
                                                        variant="outlined" color="black" type="text" class="mb-2"
                                                        disabled></v-text-field>


                                                    <v-select v-model="getAddress.locality_id" :items="getLocality"
                                                        item-title="name" item-value="id" label="Locality"
                                                        variant="outlined" color="black" disabled></v-select>

                                                    <v-text-field v-model="getAddress.pincode" label="Pincode"
                                                        variant="outlined" color="black" type="text" class="mb-2"
                                                        disabled></v-text-field>

                                                    <v-text-field v-model="getAddress.geo_location" label="Geo Location"
                                                        variant="outlined" color="black" type="text" class="mb-2"
                                                        disabled></v-text-field>

                                                </form>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </v-col>
                            <v-divider v-if="getCart.total_amount > 0"></v-divider>
                            <v-col cols="12" sm="12" md="12">
                                <!--alert box-->
                                <v-alert type="success" v-if="orderStatus" class="text-left" border color="primary">

                                    <div v-for="(resp, i) in getOrderResponse" :key="i" class="text-white">
                                        {{ resp }}
                                    </div>
                                </v-alert>
                                <v-alert type="error" v-if="orderStatusError" class="text-left" border>

                                    <div v-for="(resp, i) in getOrderResponse" :key="i" class="text-white">
                                        {{ resp }}
                                    </div>
                                </v-alert>
                                <!--alertbox end-->
                            </v-col>
                            <v-col class="text-left" cols="12" sm="12" md="12" v-if="getCart.total_amount > 0">
                                <div class="d-flex flex-wrap justify-space-between text-black ml-5">
                                    <h1 class="text-h5 font-weight-bold mt-4">
                                        Total
                                    </h1>
                                    <p class="text-h6 font-weight-bold ml-2 mt-2">
                                        Rs. {{ getCart.total_amount }}
                                    </p>
                                </div>
                                <div class="d-flex flex-wrap pa-5 justify-space-between">
                                    <div class="text-end" v-if="locationDetails.sale == true">

                                        <v-btn
                                            class="text-none text-subtitle-2 font-weight-bold mr-5 mt-5 mb-5 cart-btn"
                                            color="background" rounded variant="flat" width="200" href="/">
                                            <p class="text-black"> CONTINUE TO SHOP</p>
                                        </v-btn>

                                        <v-btn class="text-none text-subtitle-2 font-weight-bold mt-5 mb-5 cart-btn"
                                            color="primary" rounded variant="flat" width="220"
                                            @click="confirmordercheck()" v-if="userLogin == true">
                                            <p class="text-white">ORDER CONFIRM</p>
                                        </v-btn>

                                        <v-btn class="text-none text-subtitle-2 font-weight-bold mt-5 mb-5 cart-btn"
                                            color="primary" rounded variant="flat" width="220" v-if="userLogin == false"
                                            href="/login">
                                            <p class="text-white">LOGIN</p>
                                        </v-btn>


                                        <!--<v-btn class="text-none text-subtitle-2 font-weight-bold mb-5 cart-btn"
                                            color="background" rounded variant="flat" width="220" href="/checkout">
                                            PROCEED TO CHECKOUT
                                        </v-btn>-->
                                    </div>
                                </div>
                            </v-col>

                        </v-row>
                    </v-card>
                    <!--Cart Web View End-->

                    <!--Cart Mobile View-->
                    <v-card class="mx-auto bg-white d-block d-md-none d-md-none d-lg-none d-xl-none d-xxl-none"
                        elevation="0" max-width="1100">
                        <v-row dense>
                            <v-col cols="12" sm="7" md="7">
                                <v-alert type="success" color="primary" class="mt-10" v-if="getCart.total_amount == 0">
                                    <p class="text-white text-left">Your cart is currently empty. Continue to<v-btn
                                            class="text-none ml-5" color="secondary" rounded="0" variant="tonal"
                                            href="/">
                                            SHOP
                                        </v-btn></p>
                                </v-alert>
                                <v-row dense>
                                    <v-col cols="6"> </v-col>
                                    <v-col cols="6" v-if="getCart.total_amount > 0">
                                        <v-btn color="amber-accent-4" rounded variant="tonal" size="small"
                                            class="float-right" @click="clearcart()">
                                            <p class="text-black mobile-cart-btn"><v-icon
                                                    size="14">mdi-cart-remove</v-icon> Clear Cart</p>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <v-card class="ma-4 mx-auto rounded-xl " elevation="0" variant="outlined"
                                    color="#b8b8b8" v-if="getCart.total_amount > 0">
                                    <div v-for="item in getCart.cartitems" :key="item.id" class="d-flex flex-wrap">
                                        <v-avatar class="ma-3" size="50" rounded="0">
                                            <v-img :src="item.image"></v-img>
                                        </v-avatar>
                                        <div class="mobile-cart-product-details text-left">
                                            <div
                                                class="text-black font-weight-bold text-wrap mobile-product-title mt-5">
                                                {{ item.product }} - {{ item.unit }}
                                            </div>
                                            <div>
                                                <div class="rounded-xl">
                                                    <v-btn variant="text" min-height="30" class="text-center">
                                                        <p
                                                            class="text-primary price-text font-weight-bold cart-price-text">
                                                            Rs.
                                                            {{ item.base_price }}</p>
                                                    </v-btn>
                                                    <template v-if="item.max_order_qty != '0'">
                                                        <v-btn size="18" variant="flat" color="primary" icon
                                                            @click="decrement(item)">
                                                            <v-icon color="white" size="12">mdi-minus</v-icon>
                                                        </v-btn>
                                                        <span class="text-black ml-1 mr-1 cart-qty-text">{{ item.qty
                                                            }}</span>
                                                        <v-btn size="18" variant="flat" color="primary" icon
                                                            @click="increment(item)">
                                                            <v-icon color="white" size="12">mdi-plus</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <template v-else>
                                                        <v-btn color="orange" rounded variant="tonal" size="x-small">
                                                            <span class="text-black mobile-cart-btn-soldout">Sold
                                                                Out</span>
                                                        </v-btn>
                                                    </template>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <v-btn size="24" variant="outlined" color="primary" icon class="mt-3"
                                                @click="deleteItem(item)">
                                                <v-icon color="black" size="14">mdi-delete-outline</v-icon>
                                            </v-btn>
                                            <v-card-title class="mobile-product-title text-black font-weight-bold">
                                                Rs.{{ item.total_price }}
                                            </v-card-title>
                                        </div>
                                        <v-divider></v-divider>
                                    </div>
                                </v-card>
                            </v-col>
                            <v-divider v-if="getCart.total_amount > 0"></v-divider>
                            <p class="shiping-delivery-charge-content text-left" v-if="getCart.total_amount > 0">
                                *Shipping charges may
                                apply, based on your
                                location.Our staff will communicate the charges, if any, before order
                                dispatch*</p>
                            <v-divider v-if="getCart.total_amount > 0"></v-divider>
                            <v-col cols="12" sm="12" md="12" v-if="getCart.total_amount > 0">
                                <div class="d-flex flex-wrap justify-space-between text-black ml-5">
                                    <h1 class="text-h6 font-weight-bold mt-1">
                                        Total
                                    </h1>
                                    <p class="text-h7 font-weight-bold ml-2 mt-2">
                                        Rs. {{ getCart.total_amount }}
                                    </p>
                                </div>
                            </v-col>

                            <v-col cols="12" sm="12" md="12" v-if="userLogin == true">
                                <v-divider></v-divider>
                                <v-card class="mx-auto bg-white" elevation="0" v-if="getCart.total_amount > 0">
                                    <v-row dense>
                                        <v-col cols="12" sm="12" md="12">

                                            <v-card class="ma-1 rounded-xl pa-5" elevation="0" variant="outlined" dark
                                                v-if="orderStatus == false">
                                                <div class="text-right">
                                                    <v-btn class="ma-2" color="primary" @click="addressDialog = true"
                                                        variant="outlined">
                                                        <v-icon color="primary" size="25">mdi-account-edit</v-icon>
                                                        Edit
                                                    </v-btn>
                                                </div>

                                                <form class="mt-5">

                                                    <v-text-field v-model="getAddress.name" label="Name"
                                                        variant="outlined" color="black" type="text" class="mb-2"
                                                        disabled></v-text-field>

                                                    <v-text-field v-model="getAddress.mobile" label="Mobileno"
                                                        variant="outlined" color="black" type="number" class="mb-2"
                                                        disabled></v-text-field>

                                                    <v-text-field v-model="getAddress.email" label="Email"
                                                        variant="outlined" color="black" type="text" class="mb-2"
                                                        disabled></v-text-field>

                                                    <v-text-field v-model="getAddress.flat_door_no"
                                                        label="Flat / Address No" variant="outlined" color="black"
                                                        type="text" class="mb-2" disabled></v-text-field>

                                                    <v-text-field v-model="getAddress.address" label="Address"
                                                        variant="outlined" color="black" type="text" class="mb-2"
                                                        disabled></v-text-field>

                                                    <v-text-field v-model="getAddress.address2" label="Address 2"
                                                        variant="outlined" color="black" type="text" class="mb-2"
                                                        disabled></v-text-field>


                                                    <v-select v-model="getAddress.locality_id" :items="getLocality"
                                                        item-title="name" item-value="id" label="Locality"
                                                        variant="outlined" color="black" disabled></v-select>


                                                    <v-text-field v-model="getAddress.pincode" label="Pincode"
                                                        variant="outlined" color="black" type="text" class="mb-2"
                                                        disabled></v-text-field>


                                                    <v-text-field v-model="getAddress.geo_location" label="Geo Location"
                                                        variant="outlined" color="black" type="text" class="mb-2"
                                                        disabled></v-text-field>

                                                </form>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </v-col>
                            <v-divider></v-divider>
                            <v-col cols="12" sm="12" md="12">
                                <!--alert box-->
                                <v-alert type="success" v-if="orderStatus" class="mt-2  text-left" border
                                    color="primary">

                                    <div v-for="(resp, i) in getOrderResponse" :key="i" class="text-white">
                                        {{ resp }}
                                    </div>
                                </v-alert>
                                <v-alert type="error" v-if="orderStatusError" class="mt-2  text-left" border>

                                    <div v-for="(resp, i) in getOrderResponse" :key="i" class="text-white">
                                        {{ resp }}
                                    </div>
                                </v-alert>
                                <!--alertbox end-->
                            </v-col>
                            <v-col cols="12" sm="12" md="12" v-if="getCart.total_amount > 0">

                                <div class="d-flex flex-wrap pa-1 justify-space-between mt-2">


                                    <v-btn class=" font-weight-bold mr-5 mb-5 mobile-cart-btn" color="background"
                                        rounded variant="flat" href="/">
                                        <p class="text-black"> CONTINUE TO SHOP</p>
                                    </v-btn>
                                    <div v-if="locationDetails.sale == true">
                                        <v-btn class="font-weight-bold mb-5 mobile-cart-btn" color="primary" rounded
                                            variant="flat" @click="confirmordercheck()" v-if="userLogin == true">
                                            <p class="text-white">ORDER CONFIRM</p>
                                        </v-btn>
                                    </div>

                                    <v-btn class="font-weight-bold mb-5 mobile-cart-btn" color="primary" rounded
                                        variant="flat" v-if="userLogin == false" href="/login">
                                        <p class="text-white">LOGIN</p>
                                    </v-btn>


                                </div>
                            </v-col>

                        </v-row>
                    </v-card>
                    <!--Cart Mobile View End -->
                </v-col>
            </v-row>



        </v-container>

        <v-dialog width="500" v-model="addressDialog" class="rounded-xl" persistent height="auto">
            <v-card color="white" class="ma-5 pa-5 text-center">
                <v-card-title class="text-h5 mb-3">
                    Address Update
                </v-card-title>



                <v-text-field v-model="name" :error-messages="v$.name.$errors.map(e => e.$message)" label="Name*"
                    required @input="v$.name.$touch" @blur="v$.name.$touch" variant="outlined" color="black"
                    class="mb-2" type="text"></v-text-field>


                <v-text-field v-model="email" :error-messages="v$.email.$errors.map(e => e.$message)" label="Email"
                    @input="v$.email.$touch" @blur="v$.email.$touch" variant="outlined" color="black" class="mb-2"
                    type="text"></v-text-field>

                <v-text-field v-model="flat_door_no" :error-messages="v$.flat_door_no.$errors.map(e => e.$message)"
                    label="Flat / Door No*" required @input="v$.flat_door_no.$touch" @blur="v$.flat_door_no.$touch"
                    variant="outlined" color="black" class="mb-2"></v-text-field>


                <v-text-field v-model="address" :error-messages="v$.address.$errors.map(e => e.$message)"
                    label="Address*" required @input="v$.address.$touch" @blur="v$.address.$touch" variant="outlined"
                    color="black" class="mb-2"></v-text-field>

                <v-text-field v-model="address2" label="Address 2" variant="outlined" color="black"
                    class="mb-2"></v-text-field>

                <v-select v-model="locality_id" :items="getLocality" item-title="name" item-value="id" label="Locality"
                    variant="outlined" color="black"></v-select>

                <v-text-field v-model="pincode" :error-messages="v$.pincode.$errors.map(e => e.$message)"
                    label="Pincode*" required @input="v$.pincode.$touch" @blur="v$.pincode.$touch" variant="outlined"
                    color="black" class="mb-2"></v-text-field>

                <v-text-field v-model="geo_location" label="Geo Location" variant="outlined" color="black"
                    class="mb-2"></v-text-field>

                <v-divider></v-divider>

                <v-card-actions class="mt-3 text-center justify-left">
                    <v-btn class="text-none text-subtitle-2 font-weight-bold account-btn" color="primary" variant="flat"
                        rounded @click="addressFormUpdate" width="120">
                        <p class="text-white">UPDATE</p>
                    </v-btn>
                    <v-btn class="text-none text-subtitle-2 font-weight-bold account-btn" color="black" variant="flat"
                        rounded @click="addressDialog = false" width="100">
                        CLOSE
                    </v-btn>
                </v-card-actions>

                <!--alert box-->
                <v-alert type="success" v-if="addressStatusmsg" class="mt-3 text-left" border color="primary"
                    min-height="55">
                    <div class="text-white d-none  d-md-block d-md-block d-lg-block d-xl-block d-xxl-block">
                        {{ addressStatusResponse }}
                    </div>

                    <div class="text-white d-block d-md-none d-md-none d-lg-none d-xl-none d-xxl-none mb-2 alert-text">
                        {{ addressStatusResponse }}
                    </div>
                </v-alert>
                <div v-if="addressErrorStatusmsg" class="mt-3">
                    <v-alert type="error" v-for="(resp, i) in addressStatusResponse" :key="i" class="mb-1 text-left"
                        border min-height="55">
                        <div class="text-white d-none  d-md-block d-md-block d-lg-block d-xl-block d-xxl-block">
                            {{ resp }}
                        </div>

                        <div
                            class="text-white d-block d-md-none d-md-none d-lg-none d-xl-none d-xxl-none mb-2 alert-text">
                            {{ resp }}
                        </div>
                    </v-alert>
                </div>

                <!--alert box end-->
            </v-card>
        </v-dialog>

        <v-dialog width="500" v-model="orderConfirmDialog" class="rounded-xl" persistent>
            <v-card color="white" class="ma-5 pa-5 text-center">
                <v-card-title class="text-h5">
                    Order confirm?
                </v-card-title>

                <v-card-actions class="mt-3 text-center justify-center">
                    <v-btn class="text-none text-subtitle-2 font-weight-bold account-btn" color="primary" variant="flat"
                        rounded @click="confirm" width="120" :disabled="ordrBtnDisable">
                        <p class="text-white">CONFIRM</p>
                    </v-btn>
                    <v-btn class="text-none text-subtitle-2 font-weight-bold account-btn" color="black" variant="flat"
                        rounded @click="orderConfirmDialog = false" width="100">
                        CLOSE
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-snackbar v-model="addressUpdatesnackbar" :timeout="timeout" class="mb-10">
            {{ addressStatusResponse }}
        </v-snackbar>

        <v-snackbar v-model="addressErrorsnackbar" :timeout="timeout" class="mb-10">
            <div v-for="(resp, i) in addressStatusResponse" :key="i">
                <p> {{ resp }}</p>
            </div>
        </v-snackbar>

        <!--Footer Start-->
        <v-snackbar v-model="stocksnackbar" :timeout="timeout" class="mb-10">
            {{ stocksnackbartext }}
        </v-snackbar>


        <v-dialog width="500" v-model="ordererrordialog" class="rounded-xl" persistent>
            <v-card max-width="400">
                <v-card-title>
                    <div class="py-2 text-center">
                        <v-icon color="error" icon="mdi-close-circle-outline" size="128"></v-icon>
                    </div>
                </v-card-title>
                <v-card-text class=" font-weight-bold text-center mb-10">
                    <div v-for="(resp, i) in getOrderResponse" :key="i">
                        <p> {{ resp }}</p>
                    </div>
                </v-card-text>
                <v-divider></v-divider>

                <div class="pa-4 text-end">
                    <v-btn class="text-none" color="medium-emphasis" min-width="92" variant="outlined" rounded
                        @click="ordererrordialogcheck">
                        Close
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>

        <AppFooter />
    </div>

</template>

<style>
.cart-btn {
    letter-spacing: 0px !important;
    font-size: 14px !important;
    height: 48px !important;
}

.mobile-cart-btn {
    letter-spacing: 0px !important;
    font-size: 11px !important;
}

.mobile-cart-btn-soldout {
    font-size: 9px;
}

.cart-qty-text {
    font-size: 14px !important;
}

.cart-product-details {
    min-width: 280px;
}

.mobile-cart-product-details {
    min-width: 160px;
    max-width: 160px;
}

.cart-btn {
    letter-spacing: 0px !important;
    font-size: 14px !important;
    height: 48px !important;
}

.alert-text {
    font-size: 13px !important;
}

.cart-price-text {
    font-size: 12px !important;
}

.shiping-delivery-charge-content {
    font-size: 15px !important;
    margin-left: 10px;
    margin-right: 10px;
    color: red;
}
</style>
<script>
// @ is an alias to /src

import TopBar from '@/components/Bar.vue'
import AppFooter from '@/components/Footer.vue'
import LoadingView from '@/components/Loading.vue'
import { useVuelidate } from '@vuelidate/core'
import { required, numeric, email, minLength, maxLength, helpers } from '@vuelidate/validators'

import { mapActions, mapGetters } from "vuex";
export default {
    name: 'CartView',
    setup: () => ({ v$: useVuelidate() }),
    data: () => ({
        orderConfirmDialog: false,
        addressDialog: false,
        ordrBtnDisable: false,
        addressUpdatesnackbar: false,
        addressErrorsnackbar: false,
        stocksnackbar: false,
        stocksnackbartext: '',
        timeout: 2000,

    }),
    validations() {
        return {
            name: {
                required: helpers.withMessage('This field cannot be empty', required)
            },
            email: { email },
            flat_door_no: {
                required: helpers.withMessage('This field cannot be empty', required)
            },
            address: {
                required: helpers.withMessage('This field cannot be empty', required)
            },
            //locality_id: {
            // required: helpers.withMessage('This field cannot be empty', required)
            // },
            pincode: {
                required: helpers.withMessage('This field cannot be empty', required),
                numeric,
                minLength: minLength(6),
                maxLength: maxLength(6),
            },

        }
    },
    components: {
        TopBar,
        AppFooter,
        LoadingView,
    },
    created() {
        this.cartDetails();
        this.addressDetails();
        this.$store.subscribe((mutation) => {
            if (mutation.type === "orderSuccessResponse" || mutation.type === "orderError") {
                this.orderConfirmDialog = false;

            }
        });

        this.$store.subscribe((mutation) => {
            if (mutation.type === "addressReturnResponse") {
                this.addressUpdatesnackbar = true;

            }
        });
        this.$store.subscribe((mutation) => {
            if (mutation.type === "addressError") {
                this.addressErrorsnackbar = true;

            }
        });

        this.getlocationDetails();
    },
    computed: {
        ...mapGetters([
            "getCartStatus",
            "getCart",
            "getAddress",
            "getLocality",
            "getOrderStatus",
            "getOrderResponse",
            "getAddressStatus",
            "getAddressResponse",
            "getUserToken",
            "locationDetails",
        ]),
        loading: function () {
            return this.getCartStatus === "loading";
        },
        userLogin: function () {
            return this.getUserToken != "";
        },
        addressStatusmsg: function () {
            return this.getAddressStatus === "success";
        },
        addressErrorStatusmsg: function () {
            return this.getAddressStatus === "error";
        },
        addressStatusResponse: function () {
            return this.getAddressResponse;
        },
        name: {
            get() {
                return this.getAddress.name;
            },
            set(value) {
                this.$store.commit("updateCustomerName", value);
            }
        },
        email: {
            get() {
                return this.getAddress.email;
            },
            set(value) {
                this.$store.commit("updateCustomerEmail", value);
            }
        },
        flat_door_no: {
            get() {
                return this.getAddress.flat_door_no;
            },
            set(value) {
                this.$store.commit("updateCustomerFlat", value);
            }
        },
        address: {
            get() {
                return this.getAddress.address;
            },
            set(value) {
                this.$store.commit("updateCustomerAddress", value);
            }
        },
        address2: {
            get() {
                return this.getAddress.address2;
            },
            set(value) {
                this.$store.commit("updateCustomerAddress2", value);
            }
        },
        locality_id: {
            get() {
                return this.getAddress.locality_id;
            },
            set(value) {
                this.$store.commit("updateCustomerLocalityId", value);
            }
        },
        pincode: {
            get() {
                return this.getAddress.pincode;
            },
            set(value) {
                this.$store.commit("updateCustomerPincode", value);
            }
        },
        geo_location: {
            get() {
                return this.getAddress.geo_location;
            },
            set(value) {
                this.$store.commit("updateCustomerGeoLocation", value);
            }
        },
        orderStatus: function () {
            return this.getOrderStatus === "success";
        },
        orderStatusError: function () {
            return this.getOrderStatus === "error";
        },
        ordererrordialog: function () {
            return this.getOrderStatus === "error";
        },
    },
    methods: {
        ...mapActions([
            "cartDetails",
            "addTocart",
            "removeFromcart",
            "ClearCart",
            "addressDetails",
            "orderConfirm",
            "addressUpdate",
            "getlocationDetails",
        ]),
        ordererrordialogcheck() {
            this.$store.commit('orderStatusEmpty', 'success')
        },
        confirm() {
            this.ordrBtnDisable = true;
            const orderData = {
                brandslug: '',
            };
            this.orderConfirm(orderData);
            setTimeout(() => {
                this.ordrBtnDisable = false;
            }, 2000);
        },
        async addressFormUpdate() {
            //const result = await this.v$.$validate()
            //console.log(this.v$.name);
            //console.log(this.v$.name.$invalid);
            if (this.v$.name.$invalid ||
                this.v$.flat_door_no.$invalid ||
                this.v$.address.$invalid ||
                //this.v$.locality_id.$invalid ||
                this.v$.pincode.$invalid) {
                // notify user form is invalid
                console.log('enter');
                return
            }
            // perform async actions

            const addressData = {
                name: this.name,
                email: this.email,
                flat_door_no: this.flat_door_no,
                address: this.address,
                address2: this.address2,
                locality_id: this.locality_id,
                pincode: this.pincode,
                geo_location: this.geo_location
            };

            //console.log(addressData);
            this.addressUpdate(addressData);
        },
        increment(item) {
            console.log(item);
            if (item.qty < item.max_order_qty) {
                item.qty = parseFloat(item.qty) === parseFloat(item.max_order_qty) ? parseFloat(item.max_order_qty) : parseFloat(item.qty) + 1;
                item.unitSelected = item.unit_id;
                this.addTocart(item);
            } else {
                item.qty = item.max_order_qty;
                item.unitSelected = item.unit_id;
                this.addTocart(item);
                this.stocksnackbartext = item.product + ' reached maximum order qty';
                this.stocksnackbar = true;
            }
        },
        decrement(item) {
            if (item.qty <= item.max_order_qty) {
                item.qty = parseFloat(item.qty) === 0 ? 0 : parseFloat(item.qty) - 1;
                item.unitSelected = item.unit_id;
                this.addTocart(item);
            } else {
                item.qty = item.max_order_qty;
                item.unitSelected = item.unit_id;
                this.addTocart(item);
                this.stocksnackbartext = item.product + ' reached maximum order qty';
                this.stocksnackbar = true;
            }
        },
        deleteItem(item) {
            item.unitSelected = item.unit_id;
            this.removeFromcart(item);
        },
        clearcart() {
            this.ClearCart()
        },
        confirmordercheck() {
            console.log(this.getAddress.flat_door_no)
            if (this.getAddress.flat_door_no != null && this.getAddress.address != null && this.getAddress.pincode != null) {
                this.orderConfirmDialog = true
            } else {
                this.addressDialog = true
                this.stocksnackbar = true
                this.stocksnackbartext = 'Please Update Delivery Address And Confirm Order'
            }
        }


    },
}
</script>